import request from '../../config/axiosConfig';
import {
  GET_LIST_OBJECTS, CREATE_OBJECT, UPDATE_OBJECT, DELETE_OBJECT, LIST_COUNTRIES
} from '../../constants/apiEndPoint';

const objectService = {
  // Controller đọc limit/page/từ khóa từ req.body (validator đóng) nên phải gửi body whitelist,
  // và map từ khóa chung "search" của CrudPage sang đúng key "title" API nhận
  getList: async (params = {}) => {
    const { page = 1, limit = 10, search, title, type_id } = params;
    const body = { page, limit };
    const term = title ?? search;
    if (term) body.title = term;
    if (type_id !== undefined && type_id !== null && type_id !== '') body.type_id = Number(type_id);
    const { data } = await request({ url: GET_LIST_OBJECTS, method: 'POST', data: body });
    return data;
  },
  // Body-based fetch: controller đọc limit/page từ req.body nên cần gửi qua data để lấy đủ bản ghi
  getAll: async (dataBody) => {
    const { data } = await request({ url: GET_LIST_OBJECTS, method: 'POST', data: dataBody });
    return data;
  },
  create: async (dataBody) => {
    const { data } = await request({ url: CREATE_OBJECT, method: 'POST', data: dataBody });
    return data;
  },
  update: async (id, dataBody) => {
    const { data } = await request({ url: UPDATE_OBJECT, method: 'POST', data: { id, ...dataBody } });
    return data;
  },
  delete: async (id) => {
    const { data } = await request({ url: DELETE_OBJECT, method: 'POST', data: { id } });
    return data;
  },
  // Danh sách quốc gia kèm mảng thành phố (state) đã parse — dùng cho dropdown Quốc gia/Thành phố
  listCountries: async () => {
    const { data } = await request({ url: LIST_COUNTRIES, method: 'POST' });
    return data?.data || data;
  },
};

export default objectService;
